import FormWrapper from '@components/search/forms/FormWrapper'
import HeavyForm from '@components/search/forms/HeavyForm'
import { frontpageLinks } from '@components/search/formLinks'

const HeavySearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={HeavyForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={1}
            linksOnTop
        />
    )
}

export default HeavySearchpageForm